import Axios from 'axios';
import Vue from 'vue';
import i18n from '../../i18n';
import { API_HOST } from '../../config/app-const';

const state = {
  articleOrganizationScore: {
    isBusy: false,
    data: null,
    error: null
  }
};

const mutations = {
  LOAD_ARTICLE_ORGANIZATION_SCORE_BUSY: (state, payload) => {
    state.articleOrganizationScore.isBusy = payload;
  },
  LOAD_ARTICLE_ORGANIZATION_SCORE_SUCCESS: (state, payload) => {
    state.articleOrganizationScore.data = payload;
    state.articleOrganizationScore.error = null;
  },
  LOAD_ARTICLE_ORGANIZATION_SCORE_FAIL: (state, payload) => {
    state.articleOrganizationScore.data = null;
    state.articleOrganizationScore.error = payload;
  }
};

const actions = {
  getArticleOrganizationScore: ({ commit, rootState }, { projectId, articleId, organisationMentions }) => {
    commit('LOAD_ARTICLE_ORGANIZATION_SCORE_BUSY', true);

    const { accessToken } = rootState.user.user.data;
    const config = {
      headers: { Authorization: `Token token=${accessToken}` }
    };

    Axios
      .post(`${API_HOST}/analysis/editor/${projectId}/coder_article/${articleId}/score`, organisationMentions, config)
      .then(response => {
        commit('LOAD_ARTICLE_ORGANIZATION_SCORE_SUCCESS', response.data)
      })
      .catch(error => {
        Vue.notify({
          group: 'store_notifications',
          type: 'error',
          text: i18n.t('messages.request.error')});

        console.error(error);
        commit('LOAD_ARTICLE_ORGANIZATION_SCORE_FAIL', error)
      })
      .finally(() => commit('LOAD_ARTICLE_ORGANIZATION_SCORE_BUSY', false));
  }
};

export default {
  namespaced: true,
  state,
  mutations,
  actions
};